import { Component, Input, OnInit } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { HistoryTaskConfig } from './shared/history-task.config.service';
import { HistoryTaskDataService } from './shared/history-task.data.service';
import { DatePipe } from "@angular/common";

@Component({
  selector: 'iw-history-task',
  templateUrl: './history-task.component.html',
  styleUrls: ['./history-task.component.scss'],
  providers: [HistoryTaskDataService]
})
export class HistoryTaskComponent implements OnInit {
  //Tarea actual
  @Input() task_id: number;
  //Configuración de la tabla
  settings = {}
  // Información de la tabla
  source: LocalDataSource;
  //Datos para llenar la tabla
  dataTable: any[] = [];

  constructor(
    private htds: HistoryTaskDataService,
    private datePipe: DatePipe) { }

  ngOnInit() {
    const historyC = new HistoryTaskConfig();
    this.settings = historyC.settings;
    this.htds.getHistory(this.task_id).then(res=>{
      if(res){
        res.forEach((r:any) => {
          r.fecha_correo = this.datePipe.transform(r.fecha_correo, 'yyyy-MM-dd');
          this.dataTable.push(r);
        });
        this.source = new LocalDataSource(this.dataTable);
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/history-task/history-task.component.ts